export const PROJECT_HUB_SORT_OPTIONS = [
  { value: "name_asc", label: "Name (A → Z)" },
  { value: "name_desc", label: "Name (Z → A)" },
  { value: "materials_desc", label: "Materials (Highest → Lowest)" },
  { value: "materials_asc", label: "Materials (Lowest → Highest)" },
  { value: "labour_desc", label: "Labour (Highest → Lowest)" },
  { value: "labour_asc", label: "Labour (Lowest → Highest)" },
];

export const DEFAULT_PROJECT_HUB_SORT = "name_asc";

function getProjectName(project) {
  return (project?.project_name || "").toLowerCase();
}

function getMaterialCost(project, getCostSummary) {
  return Number(getCostSummary(project)?.materialCost || 0);
}

function getLabourCost(project, getCostSummary) {
  return Number(getCostSummary(project)?.labourCost || 0);
}

function compareNames(a, b, direction = 1) {
  return direction * getProjectName(a).localeCompare(getProjectName(b));
}

export function sortProjectHubList(projects, sortKey, getCostSummary = () => null) {
  const sorted = [...projects];

  switch (sortKey) {
    case "name_desc":
      return sorted.sort((a, b) => compareNames(a, b, -1));
    case "materials_desc":
      return sorted.sort(
        (a, b) =>
          getMaterialCost(b, getCostSummary) - getMaterialCost(a, getCostSummary) ||
          compareNames(a, b),
      );
    case "materials_asc":
      return sorted.sort(
        (a, b) =>
          getMaterialCost(a, getCostSummary) - getMaterialCost(b, getCostSummary) ||
          compareNames(a, b),
      );
    case "labour_desc":
      return sorted.sort(
        (a, b) =>
          getLabourCost(b, getCostSummary) - getLabourCost(a, getCostSummary) ||
          compareNames(a, b),
      );
    case "labour_asc":
      return sorted.sort(
        (a, b) =>
          getLabourCost(a, getCostSummary) - getLabourCost(b, getCostSummary) ||
          compareNames(a, b),
      );
    case "name_asc":
    default:
      return sorted.sort((a, b) => compareNames(a, b));
  }
}
